"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSelector = void 0;
var _reactRedux = require("react-redux");
var useSelector = _reactRedux.useSelector;
exports.useSelector = useSelector;